import { request } from './http';

export async function getReclaimedWaterWeekly(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/weekly?${queryParams.toString()}`);
  }

export async function getReclaimedWaterMonthly(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/monthly?${queryParams.toString()}`);
  }

export async function getReclaimedWaterBiannual(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/biannual?${queryParams.toString()}`);
  }

export async function getReclaimedWaterAnnual(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/annual?${queryParams.toString()}`);
  }

export async function getReclaimedAnalyticalMonthly(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/analytical/monthly?${queryParams.toString()}`);
  }

export async function getReclaimedAnalyticalBiannual(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/analytical/biannual?${queryParams.toString()}`);
  }

export async function getReclaimedAnalyticalAnnual(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/reclaimed/analytical/annual?${queryParams.toString()}`);
  }

export const reclaimedWaterMonitoringApi = {
  getReclaimedWaterWeekly,
  getReclaimedWaterMonthly,
  getReclaimedWaterBiannual,
  getReclaimedWaterAnnual,
  getReclaimedAnalyticalMonthly,
  getReclaimedAnalyticalBiannual,
  getReclaimedAnalyticalAnnual,
};

